import { PureComponent } from 'react'
import styled from 'glamorous'
import { $ } from 'utils'

const Container = styled.div({
  display: 'flex',
  marginBottom: 10,
}, 'infoRow')

const Name = styled.div({
  fontWeight: 'bold'
})

const Value = styled.div({
  color: 'var(--grey)',
  marginLeft: 5,
  fontSize: 14,
})


export class InfoRow extends PureComponent {
  
  render = () =>
    $(Container, {style: this.props.style},
      $(Name, this.props.name),
      $(Value, this.props.value),
    )
}

export default InfoRow



// WEBPACK FOOTER //
// ./src/components/InfoRow.js